import axios from "axios";
import Config from "./Config";
import { toast } from "sonner";

const { API_BASE_URL } = Config;
const headers = {
  "Content-Type": "application/json",
};

// ---------------------------OrderApi ------------------------
// =========================Get SendOTP=========================
export const SendOTP = async (data) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/send-otp`, data, {
      headers,
    });
    if (
      response.data.status === true
    ) {
      toast.info(response.data.OTP);
      return response.data;
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message); // Throw error with API message
    }
  } catch (error) {
    console.error(
      "Error fetching admin data:",
      error.response || error.message || error
    );
    throw error;
  }
};

// =========================Get VerifyOTP=========================
export const VerifyOTP = async (data) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/verify-otp`, data, {
      headers,
    });
    if (response.data.status === true) {
      const { Id, token, Phone, Name, Email } =
        response.data.responseData;
      sessionStorage.setItem("LoginId", JSON.stringify(Id)); // Store user data in sessionStorage
      sessionStorage.setItem("AuthToken", JSON.stringify(token)); // Store user data in sessionStorage
      sessionStorage.setItem("LoginPhone", JSON.stringify(Phone)); // Store user data in sessionStorage
      sessionStorage.setItem("LoginName", JSON.stringify(Name)); // Store user data in sessionStorage
      sessionStorage.setItem("LoginEmail", JSON.stringify(Email)); // Store user data in sessionStorage
      sessionStorage.setItem("IsLogin", JSON.stringify(true));
      toast.success(response.data.message)
      return response.data; // Return response data
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message); // Throw error with API message
    }
  } catch (error) {
    console.error(
      "Error fetching admin data:",
      error.response || error.message || error
    );
    throw error;
  }
};

// ---------------------------OrderApi ------------------------
// =========================Get SendOTP=========================
export const SendOTPUser = async (data) => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(`${API_BASE_URL}/user/send-otp`, data, {
      headers,
    });
    if (
      response.data.status === true
    ) {
      toast.info(response.data.OTP);
      return response.data;
    } else {
      toast.error(response.data.message);
      return response.data;
      throw new Error(response.data.message); // Throw error with API message
    }
  } catch (error) {
    console.error(
      "Error fetching admin data:",
      error.response || error.message || error
    );
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    throw error;
  }
};

// =========================Get VerifyOTP=========================
export const VerifyOTPUser = async (data) => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(`${API_BASE_URL}/user/verify-otp`, data, {
      headers,
    });
    if (response.data.status === true) {
      const { Phone } =
        response.data.responseData;
      sessionStorage.setItem("LoginPhone", JSON.stringify(Phone)); // Store user data in sessionStorage
      return response.data; // Return response data
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message); // Throw error with API message
    }
  } catch (error) {
    console.error(
      "Error fetching admin data:",
      error.response || error.message || error
    );
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    throw error;
  }
};

// =========================getUserdataById=========================
export const getUserdataById = async () => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.get(`${API_BASE_URL}/user/profile`, {
      headers,
    });

    if (response.data.status === true) {
      return response.data.responseData;
    } else {
      toast.error(response.data.message || "Unexpected API response");
      throw new Error(response.data.message || "API returned an error");
    }
  } catch (error) {
    console.error(
      "Error fetching User data:",
      error.response || error.message || error
    );
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    toast.error("Failed to fetch User data. Please try again later.");
    throw error;
  }
};

// ===================Edit User data================
export const UpdateUserProfile = async (data) => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.put(`${API_BASE_URL}/user/profile`, data, {
      headers,
    });

    if (response.data.status === true) {
      toast.success(response.data.message);
      sessionStorage.setItem("LoginName", JSON.stringify(response.data.responseData.Name));
      sessionStorage.setItem("LoginPhone", JSON.stringify(response.data.responseData.Phone));

      return response.data;
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error("Error updating User data:", error);
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    toast.error("Failed to update User data. Please try again.");
    throw error;
  }
};

export const UpdateUserProfile1st = async (data, token) => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.put(`${API_BASE_URL}/user/profile`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (response.data.status === true) {
      toast.success(response.data.message);
      sessionStorage.setItem(
        "LoginName",
        JSON.stringify(response.data.responseData.Name)
      );
      sessionStorage.setItem(
        "LoginEmail",
        JSON.stringify(response.data.responseData.Email)
      );
      sessionStorage.setItem("IsLogin", JSON.stringify(true)); // Store user data in sessionStorage
      return response.data;
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error("Error updating User data:", error);
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    toast.error("Failed to update User data. Please try again.");
    throw error;
  }
};
export const GoogleSignIn = async (data) => {
  const headers = {
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(`${API_BASE_URL}/user/social`, data, {
      headers
    });

    if (response.data.status === true) {
      toast.success(response.data.message);
      sessionStorage.setItem(
        "LoginName",
        JSON.stringify(response.data.responseData.Name)
      );
      sessionStorage.setItem(
        "LoginEmail",
        JSON.stringify(response.data.responseData.Email)
      );
      sessionStorage.setItem("IsLogin", JSON.stringify(true)); // Store user data in sessionStorage
      return response.data;
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error("Error updating User data:", error);
    toast.error("Failed to update User data. Please try again.");
    throw error;
  }
};
